export const CROSS = ({ color, ...props }: React.ComponentPropsWithRef<'svg'>) => (
    <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M18.3057 17.9995L54.3075 54.0014" stroke={color ?? "#FCFBF9"} strokeWidth="6" strokeLinejoin="round" />
        <path d="M54.3075 17.9991L18.3057 54.001" stroke={color ?? "#FCFBF9"} strokeWidth="6" strokeLinejoin="round" />
    </svg>
);
